/**
 * useGameTrackedLegs Hook (Web)
 * Thin wrapper around the shared useGameTrackedLegs, with the web auth's client
 */

import { API_BASE_URL } from '@config/api';
import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import type { GameTrackedLeg } from '@parlay-picker/shared/hooks';
import {
  type UseGameTrackedLegsOptions,
  useGameTrackedLegs as useGameTrackedLegsShared,
} from '@parlay-picker/shared/hooks/useGameTrackedLegs';
import { useMemo } from 'react';

export function useGameTrackedLegs(
  game: Omit<UseGameTrackedLegsOptions, 'httpClient'>,
): GameTrackedLeg[] {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useGameTrackedLegsShared({ httpClient, ...game });
}
